<div class="relativePageContainer">
  <div class="page-container">
    <div [ngClass]="isDrawerOpen? '' : 'noShadowOverlay'" class="dx-card">
      <dx-drawer
        (onInitialized)="subscribeToWindowResize()"
        [(opened)]="isDrawerOpen"
        [className]="'drawerParent'"
        [closeOnOutsideClick]="false"
        [height]="'100%'"
        [openedStateMode]="'overlap'"
        [position]="'right'"
        [revealMode]="'slide'"
        template="template">
        <div #drawerInnerContent *dxTemplate="let data of 'template'" [style.width.px]="setWidthOfDrawerPx()"
             class="drawerInnerContent" style="border-radius: 10px;">

          <div *ngIf="!!selectedGatewayType" [style.width.px]="setWidthOfDrawerPx()" class="drawerTitleWrapper">

            <h2 class="gatewayTypeName">{{ selectedGatewayType.modelName }}</h2>
            <div style="display: flex; flex-direction: row; align-items: center; gap: 10px">
              <dx-button (onClick)="enableEditMode()" *ngIf="!isEditMode" [type]="'default'" icon="edit"
                         id="editGatewayTypeButton"
                         text="{{'BUTTONS.UPDATE' | translate}}"></dx-button>
              <dx-button (onClick)="deletingGatewayType = true" *ngIf="!isEditMode" icon="trash"
                         text="{{'BUTTONS.DELETE' | translate}}"
                         type="danger"></dx-button>
              <div *ngIf="isEditMode" style="display: flex; flex-direction: row; align-items: center; gap: 10px">
                <dx-button (onClick)="saveGatewayType();"
                           [disabled]="!isEditFormValid || !gatewayTypeEdited" [stylingMode]="'contained'"
                           [type]="'default'"
                           icon="save" text="{{'BUTTONS.SAVE' | translate}}"></dx-button>
                <dx-button (onClick)="disableEditMode();" [type]="'normal'" [stylingMode]="'contained'"
                           icon="revert" text="{{'BUTTONS.CANCEL' | translate}}"></dx-button>
              </div>
              <dx-button (onClick)="closeDrawer()" *ngIf="!isEditMode" [type]="'default'"
                         [width]="30"
                         icon="close"></dx-button>
            </div>
          </div>

          <div>
            <dx-form #editGatewayTypeForm
                     (onFieldDataChanged)="checkEditGatewayTypeValidation()"
                     (onOptionChanged)="checkEditGatewayTypeValidation()"
                     [formData]="editedGatewayType"
                     [height]="'100%'"
                     [labelLocation]="'top'"
                     [labelMode]="'floating'"
            >
              <div *dxTemplate="let tab of 'titleWithValidation'" class="flexRow">
                <span>{{ tab.title }}</span>
                <div *ngIf="!checkTabValidity(tab, editGatewayTypeForm)" class="invalidBadge">!</div>
              </div>
              <dxi-item itemType="tabbed">
                <dxo-tab-panel-options [deferRendering]="false"
                                       [elementAttr]="{class: 'tabPanelAbsolute'}"></dxo-tab-panel-options>
                <dxi-tab [tabTemplate]="'titleWithValidation'"
                         title="{{'REGISTRY.GATEWAY_TYPE.TABS.INFORMATION' | translate}}">
                  <dxi-item [editorOptions]="gatewayTypeEditTextOptions" dataField="modelName">
                    <dxo-label text="{{'REGISTRY.GATEWAY_TYPE.MODEL_NAME' | translate}}"></dxo-label>
                    <dxi-validation-rule [max]="gmService.STR_DIM_MID"
                                         [message]="appService.getMaxCharErrorMessage(gmService.STR_DIM_MID)"
                                         type="stringLength"></dxi-validation-rule>
                    <dxi-validation-rule message="{{'REGISTRY.GATEWAY_TYPE.VALIDATION.MODEL_NAME' | translate}}"
                                         type="required"></dxi-validation-rule>
                  </dxi-item>

                  <dxi-item [editorOptions]="gatewayTypeEditTextOptions" dataField="partNumber">
                    <dxi-validation-rule [max]="gmService.STR_DIM_MIN"
                                         [message]="appService.getMaxCharErrorMessage(gmService.STR_DIM_MIN)"
                                         type="stringLength"></dxi-validation-rule>
                    <dxo-label text="{{'REGISTRY.GATEWAY_TYPE.PART_NUMBER' | translate}}"></dxo-label>
                  </dxi-item>

                  <dxi-item [editorOptions]="{
                      dataSource: gmService.osTypesValues,
                      displayExpr: 'label',
                      valueExpr: 'value',
                      disabled: !this.isEditMode
                  }" dataField="osType"
                            editorType="dxSelectBox"
                  >
                    <dxo-label text="{{'REGISTRY.GATEWAY_TYPE.OS_TYPE' | translate}}"></dxo-label>
                    <dxi-validation-rule message="{{'REGISTRY.GATEWAY_TYPE.VALIDATION.OS_TYPE' | translate}}"
                                         type="required"></dxi-validation-rule>
                  </dxi-item>

                  <dxi-item>
                    <dx-text-box
                      [(value)]="rtuPortName"
                      [disabled]="!isEditMode"
                      [showClearButton]="true"
                      label="{{'REGISTRY.GATEWAY_TYPE.PORT_NAME' | translate}}"
                      labelMode="floating"

                    >
                      <dxi-button
                        [options]="addRtuPortButton"
                        location="after"
                        name="today"
                      ></dxi-button>
                    </dx-text-box>

                    <dx-list (onItemDeleted)="checkEditGatewayTypeValidation()"
                             [activeStateEnabled]="false"
                             [allowItemDeleting]="isEditMode"
                             [disabled]="!isEditMode"
                             [itemDeleteMode]="'static'"
                             [items]="this.editedGatewayType?.additionalInfo?.rtuPorts!"
                             class="editable-list"
                             selectionMode="none">
                    </dx-list>
                  </dxi-item>
                </dxi-tab>
              </dxi-item>

            </dx-form>
          </div>
        </div>

        <div class="drawerOuterContent">


          <dx-data-grid
            (onRowClick)="onGatewayTypeRowClick($event)"
            [(selectedRowKeys)]="selectedRowGatewayType"
            [columnAutoWidth]="true"
            [dataSource]="gatewayTypes"
            [showBorders]="true"
            [showRowLines]="false"
            [wordWrapEnabled]="true"
            height="100%"
            id="gatewayTypeTree"
            keyExpr="id"
          >

            <dxo-toolbar>
              <dxi-item location="before">
                <p
                  style="font-size: 22px; margin: 0 0 0 10px; white-space: nowrap;">{{ 'MENU_VOICE.REGISTRY.GATEWAY_TYPES' | translate }}</p>
              </dxi-item>
              <dxi-item cssClass="fullWidthSearchBar" location="before" name="searchPanel">
              </dxi-item>
              <dxi-item location="before">
                <div *dxTemplate="let data of 'content'">
                  <dx-button (onClick)="showNewGatewayTypeForm()" hint="{{'BUTTONS.HINTS.ADD' | translate}}" icon="add"
                             stylingMode="text">
                    <i class="vr-ic_fluent_add_24_regular"></i>
                  </dx-button>
                </div>
              </dxi-item>
            </dxo-toolbar>

            <dxo-paging
              [enabled]="false">
            </dxo-paging>

            <dxo-scrolling
              mode="standard">
            </dxo-scrolling>

            <dxo-search-panel [visible]="true" placeholder="{{'PLACEHOLDERS.SEARCH' | translate}}">
            </dxo-search-panel>
            <dxo-selection mode="single"></dxo-selection>
            <dxi-column caption="{{'REGISTRY.GATEWAY_TYPE.MODEL_NAME' | translate}}" dataField="modelName"></dxi-column>
            <dxi-column caption="{{'REGISTRY.GATEWAY_TYPE.PART_NUMBER' | translate}}"
                        dataField="partNumber"></dxi-column>
            <dxi-column caption="{{'REGISTRY.GATEWAY_TYPE.OS_TYPE' | translate}}" dataField="osType"></dxi-column>

          </dx-data-grid>

        </div>

      </dx-drawer>
    </div>
  </div>

</div>

<dx-popup
  (onHiding)="addGatewayType = false"
  *ngIf="addGatewayType"
  [fullScreen]="appService.isSmallScreen()"
  [dragEnabled]="false"
  [focusStateEnabled]="false"
  [hideOnOutsideClick]="true"
  [showCloseButton]="false"
  [showTitle]="true"
  [title]="'REGISTRY.GATEWAY_TYPE.TEXT.ADD_GATEWAY_TYPE' | translate"
  [visible]="true"
  [width]="660"
>
  <dxi-toolbar-item
    location="after"
    toolbar="bottom"
  >
    <dx-button (onClick)="createNewGatewayType()" [height]="40"
               [stylingMode]="'contained'" [type]="'default'" icon="save"
               text="{{'BUTTONS.SAVE' | translate}}"></dx-button>
  </dxi-toolbar-item>
  <dxi-toolbar-item
    location="after"
    toolbar="bottom"
  >
    <dx-button (onClick)="addGatewayType = false;" [height]="40" [stylingMode]="'outlined'"
               icon="close" text="{{'BUTTONS.CANCEL' | translate}}"></dx-button>
  </dxi-toolbar-item>

  <dx-form #newGatewayTypeForm
           [formData]="newGatewayType"
           [labelLocation]="'top'"
           [labelMode]="'floating'"
  >
    <div *dxTemplate="let tab of 'titleWithValidation'" class="flexRow">
      <span>{{ tab.title }}</span>
      <div *ngIf="!checkTabValidity(tab, newGatewayTypeForm)" class="invalidBadge">!</div>
    </div>
    <dxi-item itemType="tabbed">
      <dxo-tab-panel-options [deferRendering]="false"
                             [elementAttr]="{class: 'tabPanelAbsolute'}"></dxo-tab-panel-options>
      <dxi-tab [tabTemplate]="'titleWithValidation'" title="{{'REGISTRY.GATEWAY_TYPE.TABS.INFORMATION' | translate}}">
        <dxi-item [editorOptions]="gatewayTypeNewTextOptions" dataField="modelName">
          <dxo-label text="{{'REGISTRY.GATEWAY_TYPE.MODEL_NAME' | translate}}"></dxo-label>
          <dxi-validation-rule [max]="gmService.STR_DIM_MID"
                               [message]="appService.getMaxCharErrorMessage(gmService.STR_DIM_MID)"
                               type="stringLength"></dxi-validation-rule>
          <dxi-validation-rule message="{{'REGISTRY.GATEWAY_TYPE.VALIDATION.MODEL_NAME' | translate}}"
                               type="required"></dxi-validation-rule>
        </dxi-item>

        <dxi-item [editorOptions]="gatewayTypeNewTextOptions" dataField="partNumber">
          <dxi-validation-rule [max]="gmService.STR_DIM_MIN"
                               [message]="appService.getMaxCharErrorMessage(gmService.STR_DIM_MIN)"
                               type="stringLength"></dxi-validation-rule>
          <dxo-label text="{{'REGISTRY.GATEWAY_TYPE.PART_NUMBER' | translate}}"></dxo-label>
        </dxi-item>

        <dxi-item [editorOptions]="{
                      dataSource: gmService.osTypesValues,
                      displayExpr: 'label',
                      valueExpr: 'value'
                  }" dataField="osType"
                  editorType="dxSelectBox"
        >
          <dxo-label text="{{'REGISTRY.GATEWAY_TYPE.OS_TYPE' | translate}}"></dxo-label>
          <dxi-validation-rule message="{{'REGISTRY.GATEWAY_TYPE.VALIDATION.OS_TYPE' | translate}}"
                               type="required"></dxi-validation-rule>
        </dxi-item>

        <dxi-item>
          <dx-text-box
            [(value)]="rtuPortName"
            [showClearButton]="true"
            label="{{'REGISTRY.GATEWAY_TYPE.PORT_NAME' | translate}}"
            labelMode="floating"

          >
            <dxi-button
              [options]="addRtuPortButton"
              location="after"
              name="today"
            ></dxi-button>
          </dx-text-box>

          <dx-list (onItemDeleted)="checkNewGatewayTypeValidation()"
                   [activeStateEnabled]="false"
                   [allowItemDeleting]="true"
                   [itemDeleteMode]="'static'"
                   [items]="this.newGatewayType?.additionalInfo?.rtuPorts!"
                   class="editable-list"
                   selectionMode="none">
          </dx-list>
        </dxi-item>
      </dxi-tab>
    </dxi-item>


  </dx-form>

</dx-popup>

<dx-popup
  [(visible)]="deletingGatewayType"
  [dragEnabled]="false"
  [focusStateEnabled]="false"
  [fullScreen]="appService.isSmallScreen()"
  [height]="200"
  [hideOnOutsideClick]="true"
  [showCloseButton]="false"
  [showTitle]="true"
  [title]="'REGISTRY.GATEWAY_TYPE.TEXT.DELETE_GATEWAY_TYPE' | translate"
  [width]="660"
>
  <dxi-toolbar-item
    location="after"
    toolbar="bottom"
  >
    <dx-button (onClick)="deleteGatewayType()" [height]="40" icon="trash" text="{{'BUTTONS.DELETE' | translate}}"
               type="danger"></dx-button>
  </dxi-toolbar-item>
  <dxi-toolbar-item
    location="after"
    toolbar="bottom"
  >
    <dx-button (onClick)="deletingGatewayType = false" [height]="40" [stylingMode]="'outlined'"
               icon="close" text="{{'BUTTONS.CANCEL' | translate}}"></dx-button>
  </dxi-toolbar-item>

  <div style="height: 100%; display: flex; align-items: center;">
    <label
      [innerHTML]="'REGISTRY.GATEWAY_TYPE.TEXT.CONFIRM_DELETE' | translate : {gatewayType: selectedGatewayType?.modelName}"
      style="font-size: 18px"></label>
  </div>
</dx-popup>
